import { Input, Button } from '@shared/components';
import './HeroView.css';

/**
 * View (UI) for Hero Section
 * Pure presentational component - receives all data and handlers as props
 */
export const HeroView = ({ email, onEmailChange, onSubmit, isSubmitting, message }) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero__content">
          <img 
            src="/text-no-bg.png" 
            alt="Bookiner" 
            className="hero__logo"
          />
          
          <h1 className="hero__title">
            Redonnez vie à vos livres. Découvrez votre prochaine lecture.
          </h1>
          
          <p className="hero__description">
            Bookiner est une plateforme dédiée à l'achat et à la revente de livres.<br />
            Notre ambition est de créer un espace pensé pour les lecteurs, où chaque livre peut
            trouver un nouveau propriétaire et chaque lecteur, sa prochaine découverte.
          </p>

          <form className="hero__newsletter-form" onSubmit={onSubmit}>
            <div className="hero__form-group">
              <Input
                type="email"
                name="email"
                placeholder="votre@email.com"
                value={email}
                onChange={onEmailChange}
                fullWidth
                required
                aria-label="Adresse email pour la newsletter"
              />
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Inscription...' : "S'inscrire à la newsletter"}
              </Button>
            </div>
            
            <p className="hero__helper-text">
              Soyez informé du lancement et des nouveautés de Bookiner.
            </p>

            {message.text && (
              <div className={`hero__message hero__message--${message.type}`}>
                {message.text}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default HeroView;
